import { locales } from '../../../constants/constants';
import SRS from '../../../services/StudentRecordService';
import { statusType } from '../../../services/displayStatus';
import { isNotNullOrUndefined, isNullOrUndefined } from '../../../services/util';

const armScoreForStudent = {};

export default function getArmScore(studentId, activity=null) {
  if (armScoreForStudent[studentId]){
    return armScoreForStudent[studentId];
  }
  if (!activity) return null;
  if (activity.displayStatus === "reassess") return null;
  if (shouldUseChildDyslexiaActivity(activity)) {
    const dyslexiaChildActivities = (activity.children || []).filter(act => act.type === "dyslexia")
    const dyslexiaSiblingActivities = (activity.siblings || []).filter(sibling => sibling.type === "dyslexia")
    const dyslexiaActivities = [...dyslexiaChildActivities, ...dyslexiaSiblingActivities];

    for (const dyslexiaActivity of dyslexiaActivities) {
      const {status, displayStatus, scores} = dyslexiaActivity;
      if(scores === 0) return 0;
      if(isNullOrUndefined(scores)) return null;
      const { armScore } = scores;
      if (["scored", "rescored"].includes(status) && displayStatus !== "underReview" && (armScore || armScore == 0)) return armScore;
    }
    return null;
  }
  if(!activity.scores) return null;
  // search for "ARM SPANISH SCORES" to find ARM score is determined.
  return activity.scores.armScore;
}

// fetches the most recent 5 assessment activities, and then returns the arm score from the first one that has an arm score
export const fetchARMScore = async (studentId, activities) => {
  for (const activity of activities) {
    const armScore = getArmScore(studentId, activity);
    if (isNotNullOrUndefined) return armScore;
  }
  return null;
}

// returns the first assessment that has a valid arm score
export const getARMAssessment = async (studentId, activities) => {
  for (const activity of activities) {
    const armScore = getArmScore(studentId, activity);
    if (armScore) return activity;
  }
  return null;
}


function shouldUseChildDyslexiaActivity(activity) {
  if(activity.displayStatus === statusType.PREREADER) return true;
  if(activity.displayStatus === statusType.UNASSIGNED && activity.status === statusType.NOT_STARTED) return true;
  return false;
}